import { createTheme } from '@mui/material/styles';

/** Create a theme instance. */
const theme = createTheme({
  components: {
    MuiButton: {
      // 버튼 사이즈 오버라이드
      variants: [
        {
          props: {
            size: 'xlarge'
          },
          style: {
            paddingTop: '1rem',
            paddingBottom: '1rem',
          }
        },
        {
          props: {
            size: '2xlarge'
          },
          style: {
            paddingTop: '1.5rem',
            paddingBottom: '1.5rem',
          }
        },
        {
          props: {
            size: '3xlarge'
          },
          style: {
            paddingTop: '2rem',
            paddingBottom: '2rem',
          }
        }
      ]
    }
  },
  // 팔레트 오버라이드
  palette: {
    primary: {
      main: '#bdbdbd',
      light: '#eeeeee',
      dark: '#9e9e9e',
      contrastText: '#424242', 
    },
    secondary: {
      main: '#ef3333',
      light: '#ff7961',
      dark: '#ba000d',
      contrastText: '#fff',
    },
    info: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
      contrastText: '#fff'
    },
    warning: {
      main: '#ed6c02',
      light: '#ff9800',
      dark: '#e65100',
      contrastText: '#fff'
    },
    success: {
      main: '#43a047',
      light: '#4caf50',
      dark: '#1b5e20',
      contrastText: '#fff'
    },
    error: {
      main: '#ef3333',
      light: '#ef5350',
      dark: '#c62828',
      contrastText: '#fff'
    },
    grey: {
      '50': '#fafafa',
      '100': '#f5f5f5',
      '200': '#eeeeee',
      '250': '#eaeaea',
      '300': '#e0e0e0',
      '400': '#bdbdbd',
      '500': '#9e9e9e',
      '600': '#757575',
      '700': '#616161',
      '800': '#424242',
      '900': '#212121',
      'A100': '#f5f5f5',
      'A200': '#eeeeee',
      'A400': '#bdbdbd',
      'A700': '#616161',
    },
  },
});

export default theme;